/**
 * Contratos zod del endpoint Clientes (incluye sus domicilios de entrega).
 */

import { z } from 'zod';
import { TipoActorSchema } from './ubicaciones';

export const DomicilioEntregaSchema = z.object({
  id: z.string().min(1),
  descripcion: z.string().min(1),
  direccion: z.string().min(1),
  /** Puede ser null para destructoras (no son punto regulatorio SNT). */
  gln: z.string().nullable(),
  tipoActor: TipoActorSchema.nullable(),
  cuit: z.string().min(1),
});

export const ClienteSchema = z.object({
  id: z.string().min(1),
  descripcion: z.string().min(1),
  cuit: z.string().min(1),
  /** Marca explícita para empresas destructoras (no tienen tipoActor SNT). */
  esDestructor: z.boolean().optional(),
  domiciliosEntrega: z.array(DomicilioEntregaSchema).min(1),
});

export const GetClientesResponse = z.array(ClienteSchema);

export type DomicilioEntrega = z.infer<typeof DomicilioEntregaSchema>;
export type Cliente = z.infer<typeof ClienteSchema>;
